/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! Real-Time Visitor Alerts — viewer.
 *  /live -> live summary + alerting sessions ; /feed -> recent persisted alerts ; POST /ack.
 *  Talks through the app's GS.api ({ok,status,data}). Auto-refreshes every 10s (pausable).
 *  Deep-linkable via ?id=<vid> (highlights that visitor's live card).
 */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["realtime-alerts"] = "1.0.0"; } catch (e) {}
  if (window.__rvaWired) return; window.__rvaWired = 1;

  var root = document.querySelector('[data-ra="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-ra="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  var HL = new URLSearchParams(location.search).get("id");
  var timer = null, paused = false;

  function ago(iso) {
    if (!iso) return "";
    var d = new Date(String(iso).replace(" ", "T") + "Z"), s = Math.max(0, (Date.now() - d.getTime()) / 1000);
    if (s < 60) return Math.floor(s) + "s ago";
    if (s < 3600) return Math.floor(s / 60) + "m ago";
    if (s < 86400) return Math.floor(s / 3600) + "h ago";
    return Math.floor(s / 86400) + "d ago";
  }

  function loadLive() {
    GS.api("/plugin/realtime-alerts/live?" + siteParam()).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      q("s-live").textContent = num(d.live_sessions || 0);
      q("s-alert").textContent = num(d.alerting || 0);
      q("s-high").textContent = num((d.by_severity && d.by_severity.high) || 0);
      q("s-opp").textContent = num((d.by_kind && d.by_kind.opportunity) || 0);
      var feed = q("feed");
      if (!d.live_sessions) { feed.innerHTML = '<div class="ra-empty">' + esc(d.note || TR('realti.f2.no_live_visitors_right_now')) + "</div>"; return; }
      if (!(d.feed || []).length) { feed.innerHTML = '<div class="ra-empty">' + num(d.live_sessions) + " live, none crossing an alert threshold.</div>"; return; }
      feed.innerHTML = d.feed.map(card).join("");
    });
  }
  function autoHref(x, p) {
    var qs = ["new=1"];
    if (p.alert_id) qs.push("alert=" + encodeURIComponent(p.alert_id));
    if (p.severity) qs.push("sev=" + encodeURIComponent(p.severity));
    if (p.kind) qs.push("kind=" + encodeURIComponent(p.kind));
    if (x.page) qs.push("page=" + encodeURIComponent(x.page));
    if (x.device) qs.push("device=" + encodeURIComponent(x.device));
    if (p.title) qs.push("name=" + encodeURIComponent(p.title));
    return "/behavioral-automation?" + qs.join("&");
  }
  function card(x) {
    var p = x.primary || {}, sc = x.scores || {};
    var extra = x.count > 1 ? '<div class="ra-more">+' + (x.count - 1) + " more on this visitor</div>" : "";
    var hl = (HL && x.vid === HL) ? " hl" : "";
    return '<div class="ra-card ' + esc(p.severity) + hl + '">' +
      '<div class="ra-card-top"><span class="ra-title">' + esc(p.title) + "</span>" +
      '<span class="ra-kind ' + esc(p.kind) + '">' + esc(p.kind) + "</span>" +
      '<span class="ra-when">' + ago(x.last_seen_at) + "</span></div>" +
      '<div class="ra-msg">' + esc(p.message) + "</div>" +
      '<div class="ra-meta">' +
      '<span class="ra-scores">I <b>' + (sc.intent || 0) + "</b> &middot; F <b>" + (sc.frustration || 0) + "</b> &middot; A <b>" + (sc.attention || 0) + "</b></span>" +
      (x.device ? "<span>" + esc(x.device) + "</span>" : "") + (x.country ? "<span>" + esc(x.country) + "</span>" : "") +
      '<span>' + esc(x.vid ? x.vid.slice(0, 10) : "") + "</span></div>" + extra +
      '<div class="ra-foot"><a class="ra-auto" href="' + autoHref(x, p) + '" title="'+TT('ra.at.create_an_automation_rule_from')+'"><i class="bi bi-gear-wide-connected"></i> Automate</a></div></div>';
  }

  function loadHistory() {
    GS.api("/plugin/realtime-alerts/feed?" + siteParam() + "&hours=24").then(function (r) {
      var d = (r && r.ok && r.data) || {};
      var host = q("history");
      if (!(d.alerts || []).length) { host.innerHTML = '<div class="ra-empty">No alerts in the last 24 hours.</div>'; return; }
      host.innerHTML = d.alerts.map(function (a) {
        return '<div class="ra-hrow' + (a.acknowledged ? " ackd" : "") + '" data-id="' + a.id + '">' +
          '<span class="ra-hsev ' + esc(a.severity) + '"></span>' +
          '<span class="ra-hmsg" title="' + esc(a.message) + '">' + esc(a.message) + "</span>" +
          (a.fire_count > 1 ? '<span class="ra-hcount">&times;' + a.fire_count + "</span>" : "") +
          '<span class="ra-hcount">' + ago(a.last_fired_at) + "</span>" +
          (a.acknowledged ? "" : '<button class="ra-hack" data-ack="' + a.id + '">Ack</button>') + "</div>";
      }).join("");
      Array.prototype.forEach.call(host.querySelectorAll("[data-ack]"), function (b) {
        b.addEventListener("click", function () { ack({ id: +b.getAttribute("data-ack") }); });
      });
    });
  }

  function ack(body) {
    GS.api("/plugin/realtime-alerts/ack?" + siteParam(), { method: "POST", body: JSON.stringify(body) })
      .then(function () { loadHistory(); })
      .catch(function () { loadHistory(); });
  }

  function tick() { if (paused) return; loadLive(); loadHistory(); }

  ready(function () {
    var pauseBtn = q("pause"), dot = q("dot");
    if (pauseBtn) pauseBtn.addEventListener("click", function () {
      paused = !paused;
      pauseBtn.innerHTML = paused ? '<i class="bi bi-play-fill"></i> Resume' : '<i class="bi bi-pause-fill"></i> Pause';
      if (dot) dot.classList.toggle("paused", paused);
      if (!paused) tick();
    });
    var rf = q("refresh"); if (rf) rf.addEventListener("click", tick);
    var aa = q("ackall"); if (aa) aa.addEventListener("click", function () { ack({ all: true }); });
    tick();
    timer = setInterval(tick, 10000);
    document.addEventListener("visibilitychange", function () { if (!document.hidden && !paused) tick(); });
  });
})();
